import React from "react";
import { useTranslation } from "react-i18next";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import Notification from "./components/Notification";

export default function Notifications({ notifications, organization, loading, error }) {
	const { t } = useTranslation();

	return (
		<LoadingContext
			data={notifications}
			loading={loading}
			error={error}
			noDataAvailableMessage={t("noNotifications", "You have no notifications")}
		>
			{notifications?.map((todo) => (
				<Notification key={todo.id} todo={todo} organization={organization} />
			))}
		</LoadingContext>
	);
}
